import React, { useCallback, useMemo, useState, useEffect } from "react";
import MicroModal from "micromodal";
import Moment from "moment";
import _ from "lodash";
import { endOfDay, isWithinInterval, parse, startOfDay } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { AutoSizer, List } from "react-virtualized";
import {
  More as OptionIcon,
  CallRemove,
  Gallery,
  DocumentText,
  InfoCircle,
  Video,
  VoiceSquare,
  UserAdd,
  Location,
  MicrophoneSlash1,
  Setting,
  MessageNotif,
  Message2,
  MessageRemove,
  MessageTick,
  ArrowSwapHorizontal,
  CallOutgoing,
} from "iconsax-reactjs";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import toast, { Toaster as ToasterSecond } from "react-hot-toast";

import {
  addAtendimento,
  addInteractionIngDesk,
  AlterScreen,
  clearConferenceExt,
  clearQtdMsg,
  CloseAttendant,
  createStatusAgent,
  deleteMessageHeader,
  GetAnotations,
  GetFileShared,
  GetHistory,
  GetInteractionsContact,
  GetMarkstar,
  InteracoesContactNumberPeer,
  SendNextAtd,
  ShowInfoDisplay,
  tratarAfterCallWork,
  UpdateRgBlockReturn,
  MuteStatusSimult,
  MuteStatus,
  activeSearchText,
} from "../../actions";
import {
  ChangeAtendimento,
  SendReadingMsg,
  SendSocketIvrCall,
} from "../../actions/websocket";
import { Tooltippy, Popover } from "../../actions/Tippy";
import { nc2Service } from "../../actions/nc2service";
import urlIngWeb from "../../actions/urlIngWeb";

import { getIconByChannel } from "../../utils/getIconByChannel";
import useAutoUpdateOnTimeout from "../../utils/useAutoUpdateOnTimeout";
import { connection_platform } from "../../services/api";

import ModalsDetails from "../../components/modals/NewModals/index";
import TransferClientModal from "../../containers/TransferClientModal";
import QueueItemV2 from "../QueueItemV2/QueueItemV2";
import UserPhoto from "../UserPhoto/userphoto";
import Typography from "../Typography";
import Checkbox from "../../components/manager-section/CheckboxIng/CheckboxIng";
import EndCallModal from "../modals/NewModals/EndCallModal";

import { ReactComponent as HappyRating } from "../../build/images/icons-rating/happy.svg";
import { ReactComponent as IndifRating } from "../../build/images/icons-rating/indifferent.svg";
import { ReactComponent as SadRating } from "../../build/images/icons-rating/sad.svg";
import { ReactComponent as NullRating } from "../../build/images/icons-rating/star-slash.svg";
import { ReactComponent as IconTransferBot } from "../../build/images/attendanceIcons/call-outgoing.svg";
import { ReactComponent as IconConsultTransfer } from "../../build/images/attendanceIcons/arrow-swap.svg";
import { ReactComponent as Search } from "../../build/images/teams/search-normal.svg";
import { ReactComponent as IconClose } from "../../build/images/closecircle22px.svg";
import { ReactComponent as DangerIcon } from "../../build/images/alertmodalinfo.svg";
import { ReactComponent as PinIcon } from "../../build/images/PinAssets/pin-v2.svg";
import { ReactComponent as UnpinIcon } from "../../build/images/PinAssets/unpin-v2.svg";

import "./chats-content.css";
import CardItem from "./components/CardItem";
import { tabulationHandler } from "../../utils/tabulationHandler";
import { pinHandler } from "../../utils/pinHandler";
import { noReadHandler } from "../../utils/noReadHandler";

const { meses, emoji } = require("../../services/data");

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    "&::before": {
      boxShadow: theme.shadows[1],
    },
  },
}));

var ipcurrent = "";
var gethostname = window.location.hostname;
var pathname = "";
var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;

  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;

  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
}

MicroModal.init();

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

const ChatsContent = ({ searchChats, pathfile, showModals = () => {} }) => {
  const dispatch = useDispatch();

  // const infoUsers = useSelector(
  //   (state) => state.informationusers,
  //   (prev, next) => _.isEqual(prev) === _.isEqual(next)
  // );
  const infoUsers = useSelector((state) => state.informationusers);
  const atdSimult = useSelector((state) => state.atdsimult);
  const messages = useSelector((state) => state.messages);
  const contactId = useSelector((state) => state.atendimento);
  const IPCurrent = useSelector((state) => state.ipcurrent);
  const statusAgent = useSelector((state) => state.status);
  const connectionsAPI = useSelector((state) => state.connectionsapi);
  const serviceURL = useSelector((state) => state.serviceurl);
  const infoDisplay = useSelector((state) => state.infodisplay);
  const ivrCallTransfer = useSelector((state) => state.ivrcalltransfer);
  const tabulatedInfos = useSelector((state) => state.tabulatedInfos);

  const [isExpanded, setIsExpanded] = useState(false);
  const [infoToTransfer, setInfoToTransfer] = useState({
    cdrid: "",
    scriptid: "",
    mediaid: "",
    queueId: "",
  });
  const [quarentineInfo, setQuarentineInfo] = useState({
    infoUsers,
    contactId: {},
    standbyId: "",
    cdrId: "",
    idAtendimento: "",
  });
  const [allChats, setAllChats] = useState(true);
  const [atdArray, setAtdArray] = useState([]);
  const [totalDontRead, setTotalDontRead] = useState(0);
  const [isTippyOpen, setIsTippyOpen] = useState(false);
  const [openTooltipId, setOpenTooltipId] = useState(null);
  const [transfers, setTransfers] = useState([]);
  const [searchUra, setSearchUra] = useState("");
  const [auxIvrRadio, setAuxIvrRadio] = useState(0);
  const [auxIvr, setAuxIvr] = useState([]);
  const [monitorTransfer, setMonitorTransfer] = useState(false);
  const [chatSelected, setChatSelected] = useState(false);
  const [formattedMessages, setFormattedMessages] = useState({});
  const [openFilter, setOpenFilter] = useState(false);
  const [filterOrder, setFilterOrder] = useState(
    localStorage.getItem("filterOrder")
      ? localStorage.getItem("filterOrder")
      : "order",
  );

  const getChatStatus = (call, messages, tmnoreply) => {
    let classe = "";
    let tempoExcedido = "";

    const msgs = messages[call.idatendimento];
    if (!msgs || msgs.length === 0 || tmnoreply <= 0) {
      return { classe, tempoExcedido };
    }

    const lastMsg = msgs[msgs.length - 1];
    const { dataenvio, destiny, author } = lastMsg;

    const isLastFromMe = author === "Me";

    const formatDate = Moment(dataenvio, "DD/MM/YYYY HH:mm:ss").format(
      "MM/DD/YYYY HH:mm:ss",
    );
    const diffDate = Moment().diff(formatDate, "seconds");

    if (diffDate >= tmnoreply) {
      if (destiny === "Gestor" && !isLastFromMe) {
        classe = "managerExpirated";
      } else if (destiny === "cliente" && !isLastFromMe) {
        classe = "clientExpirated";
      } else if (isLastFromMe) {
        classe = "operatorExpirated";
      }

      if (!isLastFromMe) {
        tempoExcedido = "excedido";
      }
    }

    return { classe, tempoExcedido };
  };

  const getFormattedLastInteractionDate = (call, messages, messageInfos) => {
    let lastDate = call.datatimeatd;
    let destinomsg = null;

    if (messages[call.idatendimento]) {
      // const lastMsg = messages[call.idatendimento].at(-1);
      const lastMsg = messageInfos
        ? messageInfos
        : messages[call.idatendimento].at(-1);
      const hasData = !!lastMsg.dataenvio && lastMsg.dataenvio !== "undefined";

      if (hasData) {
        lastDate = lastMsg.dataenvio;
        destinomsg = lastMsg.destiny;
      } else {
        const { dia, anoenvio, datatime } = lastMsg || {};
        if (dia && anoenvio && datatime) {
          const arrDia = dia.split(" ");
          if (Array.isArray(arrDia) && arrDia.length >= 3) {
            const day = arrDia[0];
            const monthIndex = meses.indexOf(arrDia[2].toLowerCase());

            if (monthIndex >= 0 && monthIndex < 12) {
              const month = String(monthIndex + 1).padStart(2, "0");
              const dateString = `${day}/${month}/${anoenvio} ${datatime}`;
              lastDate = dateString;
            }
          }
        }
      }
    }

    const dateObj = Moment(lastDate, "DD/MM/YYYY HH:mm:ss");
    const now = Moment();

    const isToday = now.isSame(dateObj, "day");
    const isYesterday = now.clone().subtract(1, "day").isSame(dateObj, "day");

    if (isToday) {
      return { formatted: dateObj.format("HH:mm"), destinomsg };
    }

    if (isYesterday && destinomsg !== "Me") {
      return { formatted: "Ontem", destinomsg };
    }

    return { formatted: dateObj.format("DD/MM/YYYY"), destinomsg };
  };

  const determineTypeName = (fileExtension, valueDefault) => {
    switch (fileExtension.toLowerCase()) {
      case "jpeg":
      case "png":
      case "webp":
      case "jpe":
      case "gif":
      case "bmp":
      case "jpg":
        return { type: "image", nameType: "Imagem" };
      case "pdf":
      case "zip":
      case "xls":
      case "xml":
      case "xlsx":
      case "xlsm":
      case "txt":
      case "doc":
      case "docx":
      case "ppt":
      case "pptx":
      case "ppsx":
        return { type: "document", nameType: "Arquivo" };
      case "wav":
      case "mp3":
      case "ogg":
      case "aac":
      case "m4a":
      case "amr":
      case "opus":
      case "mpeg":
        return { type: "audio", nameType: "Aúdio" };
      case "m4v":
      case "mp4":
        return { type: "video", nameType: "Vídeo" };
      default:
        return { type: "document", nameType: "Arquivo" };
    }
  };

  const getDurationAudio = async (url) => {
    return new Promise((resolve, reject) => {
      const audio = new Audio();
      audio.src = url;
      audio.addEventListener("loadedmetadata", () => {
        const duration = Math.floor(audio.duration);
        const mins = Math.floor(duration / 60)
          .toString()
          .padStart(2, "0");
        const secs = Math.floor(duration % 60)
          .toString()
          .padStart(2, "0");
        resolve(`${mins}:${secs}`);
      });
      audio.addEventListener("error", () => {
        resolve("Audio");
      });
    });
  };

  const getFormattedLastMessage = async (call, messages) => {
    let message = "";
    let msgIcon = "";
    let messageInfos = {};
    let typename = "";

    const iconMap = {
      image: <Gallery variant="outline" color="#757575" />,
      video: <Video variant="outline" color="#757575" />,
      document: <DocumentText variant="outline" color="#757575" />,
      audio: <VoiceSquare variant="outline" color="#757575" />,
      contact: <UserAdd variant="outline" color="#757575" />,
      location: <Location variant="outline" color="#757575" />,
    };

    const getIconAndMessageForMedia = async (lastMsg) => {
      const [thumbnail, captionRaw, url, size] = lastMsg.message.split("~¿");
      let cleanCaption = captionRaw ? captionRaw.trim() : captionRaw;
      let caption = (
        cleanCaption === "null" || !cleanCaption
          ? ""
          : captionRaw.replace(/¿/gi, "")
      )
        .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
        .replaceAll("\n", "")
        .replaceAll('"}', "")
        .replaceAll("\\n", "")
        .replaceAll("\r", "")
        .replace(/_(.*?)_/g, "$1");

      if (url) {
        const [pathWithoutExtension, extensionRaw] = url.split(".");
        const extension = extensionRaw ? extensionRaw.toLowerCase() : "";
        const { type, nameType } = determineTypeName(extension, "document");
        const fileName = `${pathWithoutExtension
          .split("/")
          .pop()}.${extension}`;

        const icon = iconMap[type] || "📎";
        const audioDuration =
          type === "audio"
            ? await getDurationAudio(`${urlIngWeb}${url}`)
            : null;

        return {
          message: type === "audio" ? audioDuration : caption || nameType,
          icon,
        };
      }

      return { message: caption, icon: "" };
    };

    if (messages[call.idatendimento]) {
      const lastMsg = messages[call.idatendimento].at(-1);
      messageInfos = lastMsg;

      // if (
      //   lastMsg.statusmsg === "error" &&
      //   connection_platform.isStatusOfErrorInSendMessage
      // ) {
      //   message = <i>Falha no envio da mensagem</i>;
      //   msgIcon = <InfoCircle variant="Bold" color="#c90000" />;
      // } else {
      switch (lastMsg.typemsg) {
        case "0":
          let mensagem_tratada = lastMsg.message.replace(/¿/gi, "\n");
          message = mensagem_tratada
            .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
            .replaceAll("\n", "")
            .replaceAll('"}', "")
            .replaceAll("\\n", "")
            .replaceAll("\n", "")
            .replaceAll("\\r", "")
            .replaceAll("\r", "")
            .replace(/_(.*?)_/g, "$1");
          break;

        case "1": {
          const result = await getIconAndMessageForMedia(lastMsg);
          message = result.message;
          msgIcon = result.icon;
          break;
        }

        case "2": {
          const [rawText, url] = lastMsg.message
            .replace(/§/gi, "\r\n")
            .split("~¿");
          const messageSeparada = rawText
            .replace(/¿¿/gi, "")
            .replace(/¿/gi, "")
            .trim();

          let icon = "";
          let fileName = "";
          let textSpan = "";

          if (url && url !== "null" && url !== "undefined") {
            const [pathWithoutExtension, extensionRaw] = url.split(".");
            const extension = extensionRaw ? extensionRaw.toLowerCase() : "";
            const { type, nameType } = determineTypeName(extension, "document");
            fileName = `${pathWithoutExtension.split("/").pop()}.${extension}`;
            icon = iconMap[type] || "📎";

            if (type === "audio") {
              message = await getDurationAudio(`${urlIngWeb}${url}`);
            } else {
              const editmsg = messageSeparada
                .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
                .replaceAll("\n", "")
                .replaceAll('"}', "")
                .replaceAll("\\n", "")
                .replaceAll("\r", "")
                .replace(/_(.*?)_/g, "$1");

              message = editmsg || nameType;
            }
          } else {
            const editmsg = messageSeparada
              .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
              .replaceAll("\n", "")
              .replaceAll('"}', "")
              .replaceAll("\\n", "")
              .replaceAll("\r", "")
              .replace(/_(.*?)_/g, "$1");

            message = editmsg;
          }

          msgIcon = icon;
          break;
        }

        case "4":
          let infosLocation = lastMsg.message.split("~¿");

          message = `${infosLocation[1]} ${infosLocation[0]}`;
          msgIcon = iconMap["location"] || "📎";
          break;

        case "11":
          const cleanedJsonString = lastMsg.message.replace(
            /\\(?!["\\/bfnrtu])/g,
            "",
          );
          const contactInfo = JSON.parse(
            cleanedJsonString.replace(/(?<!\w)'|'(?!\w)/g, '"'),
          );

          message = contactInfo.name.formatted_name;
          msgIcon = iconMap["contact"] || "📎";
          break;
        default:
          break;
      }
      // }
      if (
        lastMsg.statusmsg === "error" &&
        connection_platform.isStatusOfErrorInSendMessage
      ) {
        msgIcon = <InfoCircle variant="Bold" color="#c90000" />;
      }
    }

    return {
      lastMsg: message,
      msgIcon,
      messageInfos,
    };
  };

  const changeAtdSimult = (
    infouser,
    atendimento,
    atdsimultaneo,
    ipcurrent,
    status,
  ) => {
    dispatch(
      addAtendimento(
        atendimento.idatendimento,
        atendimento.cliente,
        atendimento.telefone,
        atendimento.servico,
        atendimento.datatimeatd,
        atendimento.criticidade,
        atendimento.menubot,
        atendimento.subservico,
        atendimento.serviceatd,
        atendimento.recuperation,
        atendimento.time,
        atendimento.direction,
        atendimento.idmidia,
        atendimento.timecomplete,
        atendimento.statusagent,
        atendimento.line,
        atendimento.queueid,
        atendimento.serverid,
        atendimento.qtdmessage,
        atendimento.pathfile,
        atendimento.mcdu,
        atendimento.nomesubservico,
        atendimento.infoinitcall,
        atendimento.nomecliente,
        atendimento.protocolo,
        atendimento.idsubservico,
        atendimento.acw,
        atendimento.isDialNc2,
        atendimento.arrayChannels,
        atendimento.caseId,
        atendimento.statusatd,
        atendimento.score_class,
        atendimento.score_value,
        atendimento.nps_call,
        atendimento.isTabulation,
        atendimento.enterpriseAdditionalInfos,
        atendimento.contactAdditionalInfos,
        atendimento.lastCdrClicked,
        atendimento.responsavelPor,
        atendimento.contactId,
      ),
      InteracoesContactNumberPeer(atendimento.telefone, infouser.idgroup),
      UpdateRgBlockReturn(infouser, status),
      ChangeAtendimento(
        infouser,
        atendimento,
        atdsimultaneo,
        ipcurrent,
        status,
      ),
      clearQtdMsg(atdsimultaneo.idatendimento),
    );
    SendReadingMsg(atendimento, infouser);

    dispatch(clearQtdMsg(atendimento.idatendimento));
    dispatch(GetHistory([]));
    dispatch(GetInteractionsContact([]));
    dispatch(GetMarkstar([]));
    dispatch(GetFileShared([]));
    dispatch(GetAnotations([]));
  };

  const alterStatus = (data, reason) => {
    dispatch(
      createStatusAgent(data, reason, Moment().format("DD/MM/YYYY HH:mm:ss")),
    );
  };

  const sendInfoInteractionIngDesk = (ContactId) => {
    let url_iframe = "";

    if (serviceURL.length !== 0) {
      let ArrayServiceURL = "";
      if (infoUsers.nameauth === "IngDesk") {
        ArrayServiceURL = serviceURL.filter(
          (url) => url.typeofcrm === "IngDesk",
        );
        if (ArrayServiceURL.length !== 0) {
          url_iframe = ArrayServiceURL[0].param;
        }
      }
    }
    // url_iframe = "http://localhost:3000";

    if (url_iframe !== "") {
      let channel = "0";

      if (parseInt(ContactId.idmidia) === 1) channel = "Voz";
      else if (parseInt(ContactId.idmidia) === 5) channel = "Whatsapp";
      else if (parseInt(ContactId.idmidia) === 8) channel = "Telegram";

      let jsonIngDesk = {
        origin: "ingweb",
        id: "currentInteraction",
        payload: {
          clientId: null,
          clientName: ContactId.cliente,
          channelId: ContactId.idmidia,
          channelName: channel,
          destination: ContactId.telefone,
          protocol: ContactId.protocolo,
        },
      };
      connectionsAPI.iframe_ref.current.contentWindow.postMessage(
        jsonIngDesk,
        url_iframe,
      );
      dispatch(addInteractionIngDesk(jsonIngDesk.payload));
      connectionsAPI.iframe_ref.current.contentWindow.postMessage(
        {
          origin: "ingweb",
          id: "getContactIdInteraction",
          telefone: ContactId.telefone,
        },
        url_iframe,
      );
    }

    // this.setState({ activeCrm: true }); VÊ ISSO AQ
  };

  const changeAtd = (
    infouser,
    atendimento,
    atdsimultaneo,
    ipcurrent,
    status,
  ) => {
    let atendimentoid = atendimento.idatendimento;
    // mensagensnaolidas[atendimento.idatendimento] = false;
    let contactid = contactId;
    let textMessage = [];

    let nov = [];

    if (infoDisplay.infodisplay !== "Clientes") {
      dispatch(ShowInfoDisplay("Clientes"));
      dispatch(AlterScreen("Clientes"));
    }

    // this.props.clearConference(atendimento);
    dispatch(clearConferenceExt(atendimento));
    console.log("23j4j235j", atendimento);
    localStorage.setItem("current-service", atendimento.idatendimento);

    // if (!this.state.mute) {
    //   nov[contactid.idatendimento] = this.state.mute;
    // }
    // if (!this.state.pause) {
    //   nov[contactid.idatendimento] = this.state.mute;
    // }

    changeAtdSimult(infouser, atendimento, atdsimultaneo, ipcurrent, status);

    if (atendimento.direction == "2" && atendimento.line == "0") {
      if (atendimento.acw === true)
        alterStatus("Aftercallwork", "S.(" + atendimento.telefone + ")");
      else alterStatus("Atendimento", "S.(" + atendimento.telefone + ")");
    } else if (atendimento.direction == "1" && atendimento.line == "0") {
      if (atendimento.acw === true)
        alterStatus("Aftercallwork", "S.(" + atendimento.telefone + ")");
      else alterStatus("Atendimento", "E.(" + atendimento.telefone + ")");
    } else if (atendimento.line != "0" && atendimento.direction == "2") {
      if (atendimento.acw === true)
        alterStatus("Aftercallwork", "S.(" + atendimento.telefone + ")");
      else alterStatus("Ligação", "S.(" + atendimento.telefone + ")");
    } else if (atendimento.line != "0" && atendimento.direction == "1") {
      if (atendimento.acw === true)
        alterStatus("Aftercallwork", "S.(" + atendimento.telefone + ")");
      else alterStatus("Ligação", "E.(" + atendimento.telefone + ")");
    }

    // this.setState({ buttonMore: false });
    sendInfoInteractionIngDesk(atendimento);
    // typeSearch: "search"
    // newFormatted[call.idatendimento]
    const findMsg = formattedMessages[atendimento.idatendimento];
    if (
      searchChats &&
      searchChats.trim().toLowerCase() &&
      findMsg.typeSearch === "search"
    ) {
      dispatch(activeSearchText(searchChats));
    }

    setTimeout(() => {
      if (textMessage[atendimento.idatendimento] !== undefined) {
        document.getElementById("chat-message").innerText =
          textMessage[atendimento.idatendimento];
      }
      // else {
      //   document.getElementById("chat-message").innerText = "";
      // }
      // this.setState({ editableQuickAnswer: false });
      if (document.getElementById("chat-message")) {
        document.getElementById("chat-message").contentEditable = true;
      }
    }, 100);
  };

  const actionScheduleNc2 = () => {
    nc2Service.nc2ObterResultados(dispatch);
    nc2Service.nc2ObterTelefones(dispatch);
    MicroModal.show("modal__encerrar-atendimento");
  };

  const byeCall = (
    event,
    contactid,
    infousers,
    atdsimult,
    novamensagem,
    reason,
    ipcurrent,
    status,
  ) => {
    event.preventDefault();

    if (
      infousers.classificationcount > 0 &&
      !tabulationHandler.hasAnyTabulatedInfo(tabulatedInfos, contactid)
    ) {
      document.getElementById("chat-action-add-tabulator").click();
      const timeOutIdClassification = setTimeout(() => {
        toast.remove();
        clearTimeout(timeOutIdClassification);
      }, 7000);
      toast.custom(
        <div className="container__pause-automatic-tabulator">
          <div className="container__pause-automatic__icon">
            <DangerIcon />
          </div>
          <div className="container__pause-automatic__separator">
            <div className="container__pause-automatic__box">
              <strong>
                Atenção! Encerre a conversa tabulando o atendimento.
              </strong>
              <div
                className="container__pause-automatic__box-icon"
                onClick={(event) => toast.remove(event)}
              >
                <IconClose />
              </div>
            </div>
            <span>
              Efetue a tabulação deste atendimento, logo após poderá efetuar o
              encerramento.
            </span>
          </div>
        </div>,
        {
          id: 2,
          position: "top-left",
        },
      );
      return true;
    }

    if (
      infousers.classificationcount > 0 &&
      !tabulationHandler.hasAnyTabulatedInfo(tabulatedInfos, contactid) &&
      infousers.tmoutacw === 0
    ) {
      document.getElementById("chat-action-add-tabulator").click();
      const timeOutIdClassification = setTimeout(() => {
        toast.remove();
        clearTimeout(timeOutIdClassification);
      }, 7000);
      toast.custom(
        <div className="container__pause-automatic-tabulator">
          <div className="container__pause-automatic__icon">
            <DangerIcon />
          </div>
          <div className="container__pause-automatic__separator">
            <div className="container__pause-automatic__box">
              <strong>
                Atenção! Encerre a conversa tabulando o atendimento.
              </strong>
              <div
                className="container__pause-automatic__box-icon"
                onClick={(event) => toast.remove(event)}
              >
                <IconClose />
              </div>
            </div>
            <span>
              Efetue a tabulação deste atendimento, logo após poderá efetuar o
              encerramento.
            </span>
          </div>
        </div>,
        {
          id: 2,
          position: "top-left",
        },
      );
      return true;
    }

    var permissionclose = true;

    if (
      connection_platform.nc2_integration === true &&
      connection_platform.nc2_users.indexOf(infousers.ramal) !== -1
    ) {
      if (
        infousers.nc2schedule !== true &&
        contactid.isDialNc2 === true &&
        contactid.acw === true &&
        (contactid.nomesubservico !== "CAMPANHA" ||
          (status.status !== "Chamando" && status.status !== "Discando"))
      ) {
        if (infousers.numbersnc2 !== 0) {
          actionScheduleNc2();
        } else if (infousers.reasonsnc2) {
          actionScheduleNc2();
        }
        permissionclose = false;
      }
    }

    if (permissionclose) {
      var button = document.getElementById("chat-action-shutdown");

      if (button && !button.getAttribute("disabled") !== "disabled") {
        button.setAttribute("disabled", "disabled");
        setTimeout(function () {
          button.removeAttribute("disabled");
        }, 1000);
      }

      dispatch(CloseAttendant(contactid, infousers, reason));
      dispatch(deleteMessageHeader(contactid.telefone));

      if (atdsimult.length > 1) {
        let i = 0;
        if (atdsimult[0].idatendimento == contactid.idatendimento) i = 1;

        //considerar acw em qualquer midia
        // if(parseInt(contactid.idmidia) === 1){
        if (infousers.tmoutacw === 0 && parseInt(contactid.idmidia) !== 1) {
          const storageAtdActually = localStorage.getItem("current-service");
          if (
            storageAtdActually &&
            parseInt(contactid.idatendimento) !== parseInt(storageAtdActually)
          ) {
            const indice = atdsimult.findIndex(
              (item) =>
                parseInt(item.idatendimento) === parseInt(storageAtdActually),
            );
            if (indice !== -1) {
              i = indice;
              localStorage.removeItem("current-service");
            }
          }
          dispatch(
            SendNextAtd(
              atdsimult[i],
              novamensagem,
              contactid,
              infousers,
              ipcurrent,
              atdsimult,
            ),
          );
          setTimeout(() => {
            sendInfoInteractionIngDesk(atdsimult[i]);
          }, [500]);
        } else if (infousers.tmoutacw !== 0 && contactid.acw === true) {
          const storageAtdActually = localStorage.getItem("current-service");
          if (
            storageAtdActually &&
            parseInt(contactid.idatendimento) !== parseInt(storageAtdActually)
          ) {
            const indice = atdsimult.findIndex(
              (item) =>
                parseInt(item.idatendimento) === parseInt(storageAtdActually),
            );
            if (indice !== -1) {
              i = indice;
              localStorage.removeItem("current-service");
            }
          }
          dispatch(
            SendNextAtd(
              atdsimult[i],
              novamensagem,
              contactid,
              infousers,
              ipcurrent,
              atdsimult,
            ),
          );
          setTimeout(() => {
            sendInfoInteractionIngDesk(atdsimult[i]);
          }, [500]);
        }

        // considerar acw em qualquer midia
        // }else if(parseInt(contactid.idmidia) !== 1){
        //   this.props.ProximoAtendimento(atdsimult[i],novamensagem,contactid,infousers,ipcurrent);
        // }
        // document.getElementById("chat-message").innerText = atdsimult[i].msg;
        if (document.getElementById("chat-message")) {
          document.getElementById("chat-message").innerText = "";
        }
      }
      if (
        infousers.tmoutacw !== 0 &&
        contactid.acw !== true &&
        parseInt(contactid.idmidia) !== 1
      ) {
        dispatch(
          tratarAfterCallWork(infousers.tmoutacw, contactid.serviceatd, false),
        );
      } else if (infousers.tmoutacw !== 0 && contactid.acw === true) {
        dispatch(
          tratarAfterCallWork(infousers.tmoutacw, contactid.serviceatd, true),
        );
      }

      if (contactid.acw !== true) {
        // InsertActivityATT(
        //   contactid.serviceatd,
        //   16,
        //   infousers.id,
        //   "Operador clicou em encerrar"
        // );
      }
    }

    if (document.getElementById("chat-message")) {
      document.getElementById("chat-message").contentEditable = true;
    }
  };

  const changeDisplayTransfer = (e, cdrid, serverid, usermon, mediaid) => {
    setMonitorTransfer(true);
    localStorage.setItem("idcdr", cdrid);
    localStorage.setItem("serverid", serverid);
    localStorage.setItem("usermon", usermon);
    localStorage.setItem("mediaidTransfer", mediaid);

    setTimeout(() => {
      MicroModal.show("modal__transferir__chamada");
    }, 500);
  };

  const filterOptions = (transfer) => {
    if (searchUra) {
      if (transfer.name.toLowerCase().includes(searchUra.toLowerCase())) {
        return transfer;
      } else {
        return;
      }
    } else {
      return transfer;
    }
  };

  const giveBackRadio = (e, serviceinid, todosids) => {
    if (auxIvrRadio === serviceinid) {
      setAuxIvrRadio(0);
    } else {
      setAuxIvrRadio(serviceinid);
    }
  };

  const giveBackCheckbox = (e, serviceinid) => {
    if (e.target.checked) {
      setAuxIvr(auxIvr.concat([serviceinid]));
    } else {
      setAuxIvr(
        auxIvr.filter(function (val) {
          return val != serviceinid;
        }),
      );
    }
  };

  const setTransferIvr = (
    e,
    todosids,
    chat,
    infousers,
    atdsimult,
    novamensagem,
    ipcurrent,
  ) => {
    document.getElementById("simulation_click").click();
    var serviceinid = auxIvr;

    var teste = [];
    if (auxIvrRadio != 0) {
      var ivrradio = auxIvrRadio;
      serviceinid = serviceinid.concat([ivrradio]);
    }
    if (serviceinid.length != 0) {
      for (let i = 0; i < todosids.length; i++) {
        teste.push(todosids[i].id);
        var myCheckbox = "";
        if (todosids[i].ura === false) {
          myCheckbox = document.getElementById(
            "checkboxChats" + todosids[i].id,
          );
          if (myCheckbox != null) myCheckbox.checked = false;
        }
        if (todosids[i].ura === true) {
          myCheckbox = document.getElementById("radioChats" + todosids[i].id);
          if (myCheckbox != null) myCheckbox.checked = false;
        }
      }

      const socket = SendSocketIvrCall(chat, serviceinid, infousers);

      if (atdsimult.length > 1) {
        let i = 0;
        if (atdsimult[0].idatendimento == chat.idatendimento) i = 1;

        dispatch(CloseAttendant(chat, infousers, "URA"));
        dispatch(
          SendNextAtd(
            atdsimult[i],
            novamensagem,
            chat,
            infousers,
            ipcurrent,
            atdsimult,
          ),
        );
      } else {
        dispatch(CloseAttendant(chat, infousers, "URA"));
      }

      if (
        infousers.tmoutacw !== 0 &&
        chat.acw !== true &&
        parseInt(chat.idmidia) !== 1
      ) {
        dispatch(
          tratarAfterCallWork(infousers.tmoutacw, chat.serviceatd, false),
        );
      }

      setAuxIvr([]);
      setAuxIvrRadio(0);
      setChatSelected(false);
      MicroModal.close("modal__bot-return");
    }
  };

  const setCancelIvr = (e, todosids) => {
    var serviceinid = auxIvr;
    todosids = todosids.transfers;

    if (serviceinid.length != 0) {
      for (let i = 0; i < todosids.length; i++) {
        if (todosids[i].ura === false) {
          var myCheckbox = document.getElementById("checkbox" + todosids[i].id);
          if (myCheckbox != null) myCheckbox.checked = false;
        }
      }
    }

    setAuxIvr([]);
    setAuxIvrRadio(0);
    setChatSelected(false);

    document.getElementById("simulation_click").click();
    MicroModal.close("modal__bot-return");
  };

  const handleSortAtd = (a, b) => {
    if (a.isPined && !b.isPined) return -1;
    if (!a.isPined && b.isPined) return 1;

    let lastDateA = a.datatimeatd;
    let lastDateB = b.datatimeatd;

    if (messages[a.idatendimento]) {
      const lastMsg = messages[a.idatendimento].at(-1);
      const hasData = !!lastMsg.dataenvio && lastMsg.dataenvio !== "undefined";

      if (hasData) {
        lastDateA = lastMsg.dataenvio;
      } else {
        const { dia, anoenvio, datatime } = lastMsg || {};
        if (dia && anoenvio && datatime) {
          const arrDia = dia.split(" ");
          if (Array.isArray(arrDia) && arrDia.length >= 3) {
            const day = arrDia[0];
            const monthIndex = meses.indexOf(arrDia[2].toLowerCase());

            if (monthIndex >= 0 && monthIndex < 12) {
              const month = String(monthIndex + 1).padStart(2, "0");
              const dateString = `${day}/${month}/${anoenvio} ${datatime}`;
              lastDateA = dateString;
            }
          }
        }
      }
    }

    if (messages[b.idatendimento]) {
      const lastMsg = messages[b.idatendimento].at(-1);
      const hasData = !!lastMsg.dataenvio && lastMsg.dataenvio !== "undefined";

      if (hasData) {
        lastDateB = lastMsg.dataenvio;
      } else {
        const { dia, anoenvio, datatime } = lastMsg || {};
        if (dia && anoenvio && datatime) {
          const arrDia = dia.split(" ");
          if (Array.isArray(arrDia) && arrDia.length >= 3) {
            const day = arrDia[0];
            const monthIndex = meses.indexOf(arrDia[2].toLowerCase());

            if (monthIndex >= 0 && monthIndex < 12) {
              const month = String(monthIndex + 1).padStart(2, "0");
              const dateString = `${day}/${month}/${anoenvio} ${datatime}`;
              lastDateB = dateString;
            }
          }
        }
      }
    }

    const dateObjA = Moment(lastDateA, "DD/MM/YYYY HH:mm:ss");
    const dateObjB = Moment(lastDateB, "DD/MM/YYYY HH:mm:ss");

    // return dateObjA - dateObjB;
    return dateObjB - dateObjA;
  };

  const handleSearchMessages = (atd, searchChats) => {
    let canSearch = false;
    let message = "";
    let verifyMsg = false;

    const iconMap = {
      image: <Gallery variant="outline" color="#757575" />,
      video: <Video variant="outline" color="#757575" />,
      document: <DocumentText variant="outline" color="#757575" />,
      audio: <VoiceSquare variant="outline" color="#757575" />,
      contact: <UserAdd variant="outline" color="#757575" />,
      location: <Location variant="outline" color="#757575" />,
    };

    const getIconAndMessageForMedia = (lastMsg) => {
      const [thumbnail, captionRaw, url, size] = lastMsg.message.split("~¿");
      let cleanCaption = captionRaw ? captionRaw.trim() : captionRaw;
      let caption = (
        cleanCaption === "null" || !cleanCaption
          ? ""
          : captionRaw.replace(/¿/gi, "")
      )
        .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
        .replaceAll("\n", "")
        .replaceAll('"}', "")
        .replaceAll("\\n", "")
        .replaceAll("\r", "")
        .replace(/_(.*?)_/g, "$1");

      if (url) {
        const [pathWithoutExtension, extensionRaw] = url.split(".");
        const extension = extensionRaw ? extensionRaw.toLowerCase() : "";
        const { type, nameType } = determineTypeName(extension, "document");
        let checkMsg =
          type === "audio"
            ? false
            : caption.toLowerCase().includes(searchChats.toLowerCase());

        return checkMsg;
      }

      return false;
    };

    if (messages[atd.idatendimento]) {
      const allMsg = messages[atd.idatendimento];
      for (const msgs of allMsg) {
        switch (msgs.typemsg) {
          case "0":
            let mensagem_tratada = msgs.message.replace(/¿/gi, "\n");
            message = mensagem_tratada
              .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
              .replaceAll("\n", "")
              .replaceAll('"}', "")
              .replaceAll("\\n", "")
              .replaceAll("\n", "")
              .replaceAll("\\r", "")
              .replaceAll("\r", "")
              .replace(/_(.*?)_/g, "$1");
            verifyMsg = message
              .toLowerCase()
              .includes(searchChats.toLowerCase());
            if (verifyMsg) {
              canSearch = verifyMsg;
            }
            break;

          case "1": {
            verifyMsg = getIconAndMessageForMedia(msgs);
            if (verifyMsg) {
              canSearch = verifyMsg;
            }
            break;
          }

          case "2": {
            const [rawText, url] = msgs.message
              .replace(/§/gi, "\r\n")
              .split("~¿");
            const messageSeparada = rawText
              .replace(/¿¿/gi, "")
              .replace(/¿/gi, "")
              .trim();

            const editmsg = messageSeparada
              .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
              .replaceAll("\n", "")
              .replaceAll('"}', "")
              .replaceAll("\\n", "")
              .replaceAll("\r", "")
              .replace(/_(.*?)_/g, "$1");

            message = editmsg.toLowerCase().includes(searchChats.toLowerCase());

            if (url && url !== "null" && url !== "undefined") {
              const [pathWithoutExtension, extensionRaw] = url.split(".");
              const extension = extensionRaw ? extensionRaw.toLowerCase() : "";
              const { type, nameType } = determineTypeName(
                extension,
                "document",
              );

              if (type === "audio") {
                message = false;
              }
            }

            verifyMsg = message;
            if (verifyMsg) {
              canSearch = verifyMsg;
            }
            break;
          }

          case "4":
            let infosLocation = msgs.message.split("~¿");

            message = `${infosLocation[1]} ${infosLocation[0]}`
              .toLowerCase()
              .includes(searchChats.toLowerCase());
            verifyMsg = message;
            if (verifyMsg) {
              canSearch = verifyMsg;
            }
            break;

          case "11":
            const cleanedJsonString = msgs.message.replace(
              /\\(?!["\\/bfnrtu])/g,
              "",
            );
            const contactInfo = JSON.parse(
              cleanedJsonString.replace(/(?<!\w)'|'(?!\w)/g, '"'),
            );

            message = contactInfo.name.formatted_name
              .toLowerCase()
              .includes(searchChats.toLowerCase());
            verifyMsg = message;
            if (verifyMsg) {
              canSearch = verifyMsg;
            }
            break;

          default:
            break;
        }
      }
    }

    return canSearch;
  };

  const getMatchingMessage = (atd, searchChats) => {
    const iconMap = {
      image: <Gallery variant="outline" color="#757575" />,
      video: <Video variant="outline" color="#757575" />,
      document: <DocumentText variant="outline" color="#757575" />,
      audio: <VoiceSquare variant="outline" color="#757575" />,
      contact: <UserAdd variant="outline" color="#757575" />,
      location: <Location variant="outline" color="#757575" />,
    };

    const search = searchChats.toLowerCase();

    if (!messages[atd.idatendimento]) return null;

    const allMsg = messages[atd.idatendimento];

    for (const msgs of allMsg) {
      let content = "";
      let icon = "";
      let hasError =
        msgs.statusmsg === "error" &&
        connection_platform.isStatusOfErrorInSendMessage;
      let iconError = <InfoCircle variant="Bold" color="#c90000" />;
      let messageInfos = {};

      switch (msgs.typemsg) {
        case "0": {
          content = msgs.message
            .replace(/¿/gi, "\n")
            .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
            .replaceAll("\n", "")
            .replaceAll('"}', "")
            .replaceAll("\\n", "")
            .replaceAll("\r", "")
            .replace(/_(.*?)_/g, "$1");

          if (content.toLowerCase().includes(search)) {
            return {
              lastMsg: content,
              msgIcon: hasError ? iconError : "",
              messageInfos: msgs,
              typeSearch: "search",
            };
          }
          break;
        }

        case "1": {
          const [thumbnail, captionRaw, url] = msgs.message.split("~¿");
          const cleanCaption = captionRaw ? captionRaw.trim() : captionRaw;
          const caption = (
            cleanCaption === "null" || !cleanCaption
              ? ""
              : cleanCaption.replace(/¿/gi, "")
          )
            .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
            .replaceAll("\n", "")
            .replaceAll('"}', "")
            .replaceAll("\\n", "")
            .replaceAll("\r", "")
            .replace(/_(.*?)_/g, "$1");

          if (url) {
            const [, extensionRaw] = url.split(".");
            const extension = extensionRaw ? extensionRaw.toLowerCase() : "";
            const { type } = determineTypeName(extension, "document");

            if (type !== "audio" && caption.toLowerCase().includes(search)) {
              icon = iconMap[type] || "";
              return {
                lastMsg: caption,
                msgIcon: hasError ? iconError : icon,
                messageInfos: msgs,
                typeSearch: "search",
              };
            }
          }
          break;
        }

        case "2": {
          const [rawText, url] = msgs.message
            .replace(/§/gi, "\r\n")
            .split("~¿");
          const caption = rawText
            .replace(/¿¿/gi, "")
            .replace(/¿/gi, "")
            .trim()
            .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1")
            .replaceAll("\n", "")
            .replaceAll('"}', "")
            .replaceAll("\\n", "")
            .replaceAll("\r", "")
            .replace(/_(.*?)_/g, "$1");

          if (url && url !== "null" && url !== "undefined") {
            const [, extensionRaw] = url.split(".");
            const extension = extensionRaw ? extensionRaw.toLowerCase() : "";
            const { type } = determineTypeName(extension, "document");

            if (type === "audio") break;
            if (caption.toLowerCase().includes(search)) {
              icon = iconMap[type] || "";
              return { lastMsg: caption, msgIcon: hasError ? iconError : icon };
            }
          } else {
            if (caption.toLowerCase().includes(search)) {
              return {
                lastMsg: caption,
                msgIcon: hasError ? iconError : "",
                messageInfos: msgs,
                typeSearch: "search",
              };
            }
          }

          break;
        }

        case "4": {
          const infos = msgs.message.split("~¿");
          const locationText = `${infos[1]} ${infos[0]}`.toLowerCase();

          if (locationText.includes(search)) {
            return {
              lastMsg: `${infos[1]} ${infos[0]}`,
              msgIcon: hasError ? iconError : iconMap["location"] || "",
              messageInfos: msgs,
              typeSearch: "search",
            };
          }
          break;
        }

        case "11": {
          try {
            const cleaned = msgs.message.replace(/\\(?!["\\/bfnrtu])/g, "");
            const contactInfo = JSON.parse(
              cleaned.replace(/(?<!\w)'|'(?!\w)/g, '"'),
            );
            const name = contactInfo.name.formatted_name;

            if (name.toLowerCase().includes(search)) {
              return {
                lastMsg: name,
                msgIcon: hasError ? iconError : iconMap["contact"] || "",
                messageInfos: msgs,
                typeSearch: "search",
              };
            }
          } catch (err) {
            console.error("Erro ao processar contato:", err);
          }
          break;
        }

        default:
          break;
      }
    }

    return null;
  };

  const renderMenu = (chat) => {
    return (
      <ul className="menu-chats menu-chats-new">
        <li
          className="menu-chats__option no-fill"
          onClick={() => {
            setChatSelected(chat);
            setTimeout(() => {
              MicroModal.show("modal__return-ura");
            }, 500);
          }}
        >
          <CallOutgoing size="16" color="#59697d" />
          <Typography.H5
            weight={500}
            color={"gray-180"}
            className={"new-menu-item"}
          >
            Devolver para o BOT
          </Typography.H5>
        </li>
        <li
          className="menu-chats__option"
          onClick={(e) => {
            changeDisplayTransfer(
              e,
              chat.idatendimento,
              chat.serverid,
              infoUsers.id,
              chat.idmidia,
            );
          }}
        >
          <ArrowSwapHorizontal size="16" color="#59697d" />
          <Typography.H5
            weight={500}
            color={"gray-180"}
            className={"new-menu-item"}
          >
            Consulta / Transferencia
          </Typography.H5>
        </li>
        {chat.idmidia === "1" && (
          <li
            className="menu-chats__option no-fill"
            onClick={() => {
              let statusAtd = chat.statusatd === 3 ? false : true;
              if (chat.idatendimento === contactId.idatendimento) {
                dispatch(MuteStatus(statusAtd));
              } else {
                dispatch(MuteStatusSimult(statusAtd, chat));
              }
            }}
          >
            <MicrophoneSlash1 size="16" color="#59697d" />
            <Typography.H5
              weight={500}
              color={"gray-180"}
              className={"new-menu-item"}
            >
              {chat.statusatd === 3 ? "Desmutar Chamada" : "Mutar Chamada"}
            </Typography.H5>
          </li>
        )}
        {pinHandler.isAllowedChannel(chat.idmidia) && (
          <li
            className="menu-chats__option pin-chat new-item"
            onClick={() => {
              if (pinHandler.isChatPinned(chat)) {
                pinHandler.unpinChat(
                  dispatch,
                  chat.idatendimento,
                  undefined,
                  chat.idmidia,
                );
              } else {
                pinHandler.pinChat(
                  dispatch,
                  chat.idatendimento,
                  undefined,
                  chat.idmidia,
                );
              }
            }}
          >
            {pinHandler.isChatPinned(chat) ? <UnpinIcon /> : <PinIcon />}
            <Typography.H5
              weight={500}
              color={"gray-180"}
              className={"new-menu-item"}
            >
              {pinHandler.isChatPinned(chat)
                ? "Desafixar conversa"
                : "Fixar conversa"}
            </Typography.H5>
          </li>
        )}
        {noReadHandler.isAllowedChannel(chat.idmidia) && (
          <li
            className="menu-chats__option pin-chat new-item"
            onClick={() => {
              if (noReadHandler.isNoReadChat(chat)) {
                noReadHandler.unmarkNoReadChat(
                  dispatch,
                  chat.idatendimento,
                  chat,
                  infoUsers,
                  undefined,
                  chat.idmidia,
                );
              } else {
                noReadHandler.markNoReadChat(
                  dispatch,
                  chat.idatendimento,
                  undefined,
                  chat.idmidia,
                );
              }
            }}
          >
            {noReadHandler.isNoReadChat(chat) ? (
              <MessageNotif size="16" color="#59697d" />
            ) : (
              <MessageNotif size="16" color="#59697d" />
            )}
            <Typography.H5
              weight={500}
              color={"gray-180"}
              className={"new-menu-item"}
            >
              {noReadHandler.isNoReadChat(chat)
                ? "Marcar como lida"
                : "Marcar como não lida"}
            </Typography.H5>
          </li>
        )}
        <li
          className="menu-chats__option end-chat"
          onClick={(event) => {
            setChatSelected(chat);
            if (!!statusAgent && statusAgent.status === "Aftercallwork") {
              byeCall(
                event,
                chat,
                infoUsers,
                atdSimult,
                messages,
                "encerramento",
                IPCurrent,
                statusAgent,
              );
            } else {
              event.preventDefault();
              MicroModal.show("modal__end-call");
            }
          }}
        >
          <CallRemove size={16} color="#EC003F" />
          <Typography.H5
            weight={500}
            color={"red-2"}
            className={"new-menu-item"}
          >
            Encerrar Atendimento
          </Typography.H5>
        </li>
      </ul>
    );
  };

  const renderFilters = () => {
    return (
      <ul className="menu-chats">
        <li
          className={`menu-chats__option order-filter ${
            filterOrder === "message" ? "active" : ""
          }`}
          onClick={(event) => {
            setFilterOrder("message");
            localStorage.setItem("filterOrder", "message");
          }}
        >
          <MessageNotif />
          <Typography.H5 weight={500} color={"gray-180"}>
            Conversas recentes
          </Typography.H5>
        </li>
        <li
          className={`menu-chats__option order-filter ${
            filterOrder === "order" ? "active" : ""
          }`}
          onClick={() => {
            setFilterOrder("order");
            localStorage.setItem("filterOrder", "order");
          }}
        >
          <Message2 />
          <Typography.H5 weight={500} color={"gray-180"}>
            Ordem de chegada
          </Typography.H5>
        </li>
      </ul>
    );
  };

  const renderModalBot = () => {
    return (
      <div
        className="modal micromodal-slide"
        id="modal__return-ura"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__return-ura__main"
          >
            <div id="return-ura">
              <div className="popover">
                <div className="popover__header">
                  <div className="popover-titles">
                    <span className="popover__header-title">
                      Devolver para o BOT
                    </span>
                    <span className="popover__header-subtitle">
                      Selecione a URA para devolver esse atendimento
                    </span>
                  </div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setChatSelected(false);
                      MicroModal.close("modal__bot-return");
                    }}
                    className="modal__close"
                    aria-label="Close modal"
                    data-micromodal-close
                  ></button>
                </div>
                <div className="popover__body">
                  <div className="full-search_container">
                    <input
                      type="text"
                      name="client-search"
                      id="client-search"
                      value={searchUra}
                      onChange={(event) => setSearchUra(event.target.value)}
                      placeholder="Pesquisar"
                    />
                    <button type="submit" className="full-search__btn">
                      <Search />
                    </button>
                  </div>
                  <div className="options-list">
                    <ul>
                      {transfers &&
                        transfers.filter(filterOptions).map((transfer) =>
                          (() => {
                            if (
                              transfer.ura === true &&
                              parseInt(transfer.idmidia) ===
                                parseInt(contactId.idmidia)
                            ) {
                              return (
                                <li key={transfer.id}>
                                  <Checkbox
                                    onChange={(event) =>
                                      giveBackRadio(
                                        event,
                                        transfer.id,
                                        ivrCallTransfer,
                                      )
                                    }
                                    radioBox={true}
                                    type="radio"
                                    name={"radioChats" + transfer.id}
                                    value={transfer.id}
                                    id={"radioChats" + transfer.id}
                                    checked={auxIvrRadio === transfer.id}
                                  />
                                  <label htmlFor={"radioChats" + transfer.id}>
                                    {transfer.name}
                                  </label>
                                </li>
                              );
                            }
                          })(),
                        )}
                      <li className="title-list">ANÚNCIO / PESQUISA</li>
                      {transfers &&
                        transfers.filter(filterOptions).map((transfer) =>
                          (() => {
                            if (
                              transfer.ura === false &&
                              parseInt(transfer.idmidia) ===
                                parseInt(contactId.idmidia)
                            ) {
                              return (
                                <li key={transfer.id}>
                                  <Checkbox
                                    onChange={(event) =>
                                      giveBackCheckbox(event, transfer.id)
                                    }
                                    typeCheck="checkbox"
                                    name={"checkboxChats" + transfer.id}
                                    id={"checkboxChats" + transfer.id}
                                    value={transfer.id}
                                    checked={auxIvr.includes(transfer.id)}
                                  />
                                  <label
                                    htmlFor={"checkboxChats" + transfer.id}
                                  >
                                    {transfer.name}
                                  </label>
                                </li>
                              );
                            }
                          })(),
                        )}
                    </ul>
                  </div>
                </div>
                <div className="popover__footer">
                  <button
                    onClick={(event) =>
                      setTransferIvr(
                        event,
                        ivrCallTransfer,
                        chatSelected,
                        infoUsers,
                        atdSimult,
                        messages,
                        IPCurrent,
                      )
                    }
                    className="btn btn-primary"
                  >
                    Devolver
                  </button>
                  <button
                    onClick={(event) => setCancelIvr(event, ivrCallTransfer)}
                    className="btn btn-secondary"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderTagInfo = (call, tempoExcedido) => {
    let qtdMessage = <></>;
    let infosSpan = <></>;
    let text = call.qtdmessage;
    if (call.acw) {
      text = "After Call Work";
    } else if (tempoExcedido) {
      text = "Tempo excedido";
    }

    if (call.qtdmessage >= 1 || call.isNoRead) {
      qtdMessage = <span className={`badge`}>{call.qtdmessage || ""}</span>;
    }

    if (call.acw || tempoExcedido) {
      infosSpan = (
        <span
          className={`badge${tempoExcedido || call.acw ? " more-width" : ""}${
            call.acw ? " acw-color" : ""
          }`}
        >
          {text}
        </span>
      );
    }

    return (
      <>
        {infosSpan} {qtdMessage}
      </>
    );
  };

  const renderProfilePicture = (idmidia, call, destinomsg) => {
    return (
      <div
        className="chats-content__body__icon"
        onClick={() =>
          changeAtd(infoUsers, call, atdSimult, IPCurrent, statusAgent)
        }
      >
        <div
          className={`msg-indicator${
            destinomsg === "Gestor"
              ? " __manager"
              : destinomsg === "cliente"
                ? " __client"
                : " __operator"
          }`}
        ></div>
        {Boolean(call) &&
          Boolean(call.cliente) &&
          typeof call.cliente === "string" && (
            <UserPhoto
              size="large"
              letterIcon={createJSON(call.cliente.trim())}
            />
          )}
        <div className="chats-content__body__icon__media">
          {getIconByChannel(idmidia)}
        </div>
      </div>
    );
  };

  // const renderCardChat = (
  //   key,
  //   call,
  //   style,
  //   classe,
  //   tempoExcedido,
  //   dateExhib,
  //   lastMsg,
  //   msgIcon,
  //   destinomsg,
  // ) => {
  //   return (
  //     <div
  //       className={`card-chats ${
  //         call.idatendimento === contactId.idatendimento ? "active" : ""
  //       } `}
  //       key={key}
  //       style={style}
  //     >
  //       <div className="card-chats__main">
  //         {renderProfilePicture(call.idmidia, call, destinomsg)}
  //         <div className="card-chats__infos">
  //           <div
  //             className="card-chats__infos-infoMsg"
  //             onClick={() =>
  //               changeAtd(infoUsers, call, atdSimult, IPCurrent, statusAgent)
  //             }
  //           >
  //             <div className="name-time">
  //               <Tooltippy
  //                 content={call.cliente ? createJSON(call.cliente) : ""}
  //               >
  //                 <Typography.H4 className={"name-info"} color={"gray-600"}>
  //                   {createJSON(call.cliente)}
  //                 </Typography.H4>
  //               </Tooltippy>
  //               <div className="datetime">{dateExhib}</div>
  //             </div>
  //             <div className="message-tag">
  //               {lastMsg && (
  //                 <Tooltippy
  //                   placement="top"
  //                   content={<span className="tippy-msg">{lastMsg}</span>}
  //                 >
  //                   <div
  //                     className={`preview-container${
  //                       tempoExcedido ? " less-width" : ""
  //                     }`}
  //                   >
  //                     {msgIcon}
  //                     <Typography.H5
  //                       className={`preview${msgIcon ? " less-width" : ""}`}
  //                       color={"gray-180"}
  //                     >
  //                       {lastMsg}
  //                     </Typography.H5>
  //                   </div>
  //                 </Tooltippy>
  //               )}
  //               {renderTagInfo(call, tempoExcedido)}
  //             </div>
  //           </div>
  //           <LightTooltip
  //             title={renderMenu(call)}
  //             placement="right"
  //             open={openTooltipId === key}
  //             onClose={() => setOpenTooltipId(null)}
  //           >
  //             <div
  //               className={`action tippy-context-menu${
  //                 openTooltipId === key ? " active" : ""
  //               }`}
  //               onClick={(e) => {
  //                 e.preventDefault();
  //                 setOpenTooltipId(openTooltipId === key ? null : key);
  //               }}
  //             >
  //               <OptionIcon variant="outline" color="#757575" />
  //             </div>
  //           </LightTooltip>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  const renderCardChat = (
    key,
    call,
    style,
    classe,
    tempoExcedido,
    dateExhib,
    lastMsg,
    msgIcon,
    destinomsg,
  ) => {
    return (
      <CardItem
        call={call}
        contactId={contactId}
        key={key}
        keyToTransfer={key}
        style={style}
        renderProfilePicture={renderProfilePicture}
        destinomsg={destinomsg}
        changeAtd={changeAtd}
        infoUsers={infoUsers}
        atdSimult={atdSimult}
        IPCurrent={IPCurrent}
        statusAgent={statusAgent}
        createJSON={createJSON}
        dateExhib={dateExhib}
        lastMsg={lastMsg}
        tempoExcedido={tempoExcedido}
        msgIcon={msgIcon}
        renderTagInfo={renderTagInfo}
        renderMenu={renderMenu}
        openTooltipId={openTooltipId}
        setOpenTooltipId={setOpenTooltipId}
        LightTooltip={LightTooltip}
      />
    );
  };

  useEffect(() => {
    console.log("INGENIUM_11_03_2026", {
      atdSimult,
      atdArray,
      loginresponse: infoUsers.loginresponse,
    });

    if (atdSimult.length > 0 && infoUsers.loginresponse) {
      // let filterAtd = atdSimult.filter(
      //   (atd) => atd.idatendimento !== contactId.idatendimento
      // );
      let filterAtd = [...atdSimult];
      if (filterOrder === "message") {
        filterAtd = filterAtd.sort(handleSortAtd);
      } else {
        const pinned = filterAtd.filter((atd) => atd.isPined);
        const unpinned = filterAtd.filter((atd) => !atd.isPined);
        filterAtd = [...pinned, ...unpinned];
      }
      let getDontRead = filterAtd.filter(
        (atd) => parseInt(atd.qtdmessage) > 0 || atd.isNoRead,
      );
      let totalRead = getDontRead.length;
      if (!allChats) {
        filterAtd = getDontRead;
      }
      if (searchChats && searchChats.trim()) {
        const search = searchChats.toLowerCase();

        filterAtd = filterAtd.filter((atd) => {
          const clienteMatch = atd.cliente.toLowerCase().includes(search);
          const telefoneMatch = atd.telefone.toLowerCase().includes(search);
          const messageMatch = handleSearchMessages(atd, search);

          return clienteMatch || telefoneMatch || messageMatch;
        });
      }

      setAtdArray(filterAtd);
      setTotalDontRead(totalRead);
      console.log("INGENIUM_11_03_2026_2", { filterAtd });
    } else if (atdSimult.length === 0) {
      setAtdArray([]);
    }
  }, [
    infoUsers,
    atdSimult,
    contactId,
    allChats,
    searchChats,
    messages,
    filterOrder,
  ]);

  useEffect(() => {
    setTransfers(ivrCallTransfer.transfers);
  }, [ivrCallTransfer]);

  useEffect(() => {
    const fetchMessages = async () => {
      const newFormatted = {};
      const search = searchChats && searchChats.trim().toLowerCase();

      for (const call of atdArray) {
        let formatted;

        const clienteMatch = call.cliente.toLowerCase().includes(search);
        const telefoneMatch = call.telefone.toLowerCase().includes(search);

        if (search && (clienteMatch || telefoneMatch)) {
          formatted = await getFormattedLastMessage(call, messages);
        } else if (search) {
          const found = getMatchingMessage(call, search);
          formatted = found || (await getFormattedLastMessage(call, messages));
        } else {
          formatted = await getFormattedLastMessage(call, messages);
        }

        newFormatted[call.idatendimento] = formatted;
      }

      setFormattedMessages(newFormatted);
    };

    fetchMessages();
  }, [atdArray, messages, contactId, searchChats]);

  const tick = useAutoUpdateOnTimeout(messages, atdArray, infoUsers.tmnoreply);

  return (
    <div className="chats-content">
      <div className="chats-content__header">
        <div
          className={`tag-chats ${allChats ? "active" : ""}`}
          onClick={() => setAllChats(true)}
        >
          <Typography.H5 weight={500} color={allChats ? "white" : "gray-180"}>
            Todas
          </Typography.H5>
        </div>
        <div
          className={`tag-chats ${!allChats ? "active" : ""}`}
          onClick={() => setAllChats(false)}
        >
          <Typography.H5 weight={500} color={!allChats ? "white" : "gray-180"}>
            Não lidas ({totalDontRead})
          </Typography.H5>
        </div>
        <LightTooltip
          title={renderFilters()}
          placement="bottom"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
        >
          <div
            className={`action tippy-context-menu${
              openFilter ? " active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              setOpenFilter(true);
            }}
          >
            <Setting color="#455CC7" variant="outline" />
          </div>
        </LightTooltip>
      </div>
      <div className="chats-content__body">
        <AutoSizer>
          {({ width, height }) => {
            const cellHeight = 80;
            const newHeight = Math.max(atdArray.length * 80, 500);
            // const orderArray = atdArray.sort(handleSortAtd);
            const rowRendered = ({ key, index, style }) => {
              // const call = orderArray[index];
              const call = atdArray[index];
              const { classe, tempoExcedido } = getChatStatus(
                call,
                messages,
                infoUsers.tmnoreply,
              );
              const { lastMsg, msgIcon, messageInfos } =
                formattedMessages[call.idatendimento] || {};
              const { formatted: lastInteractionLabel, destinomsg } =
                getFormattedLastInteractionDate(call, messages, messageInfos);

              return renderCardChat(
                key,
                call,
                style,
                classe,
                tempoExcedido,
                lastInteractionLabel,
                lastMsg,
                msgIcon,
                destinomsg,
              );
            };
            return (
              <List
                width={width}
                height={height}
                rowCount={atdArray.length}
                rowHeight={cellHeight}
                rowRenderer={rowRendered}
              />
            );
          }}
        </AutoSizer>
      </div>
      {renderModalBot()}
      {infoDisplay.infodisplay !== "Clientes" && (
        <EndCallModal
          onConfirm={(e) => {
            e.preventDefault();
            byeCall(
              e,
              chatSelected,
              infoUsers,
              atdSimult,
              messages,
              "encerramento",
              IPCurrent,
              statusAgent,
            );
          }}
        />
      )}
      {monitorTransfer && (
        <TransferClientModal
          dashboardMonitor={monitorTransfer}
          setMonitorDash={setMonitorTransfer}
        />
      )}
    </div>
  );
};

//export default React.memo(ChatsContent, (prevProps, nextProps) => {
//  return (
//    prevProps.filteredListQuarentineQueue ===
//    nextProps.filteredListQuarentineQueue
//  );
//});
export default ChatsContent;
